package com.example.mystybag.core.expected

import androidx.compose.runtime.Composable
import com.example.mystybag.core.logic.base.AppViewModel
import com.example.mystybag.core.model.SnackbarConfig
import com.example.mystybag.sharedmodels.SCImage

object PlatformHelperWrapper {

    suspend fun takePhoto(): FileModel? =
        PlatformHelper.takePhoto().let {
            it.second?.let { message ->
                AppViewModel.showSnackbar(SnackbarConfig(message))
                null
            } ?: it.first
        }

    suspend fun openGallery(): FileModel? =
        PlatformHelper.openGallery().let {
            it.second?.let { message ->
                AppViewModel.showSnackbar(SnackbarConfig(message))
                null
            } ?: it.first
        }

    suspend fun getFile(): FileModel? =
        PlatformHelper.getFile().let {
            it.second?.let { message ->
                AppViewModel.showSnackbar(SnackbarConfig(message))
                null
            } ?: it.first
        }
}

expect object PlatformHelper {
    /** True when running in browser (Web); false on Android/iOS. Use for layout differences (e.g. sidebar vs bottom nav). */
    val isWeb: Boolean
    @Composable
    fun PlatformView()
    suspend fun takePhoto(): Pair<FileModel?, String?>
    suspend fun openGallery(): Pair<FileModel?, String?>
    suspend fun getFile(): Pair<FileModel?, String?>
}

expect class FileModel(uri: String, type: FileModelType) {
    val fileType    : FileModelType
    val image       : SCImage?
    val byteArray   : ByteArray?
    val path        : String?
    val name        : String
}

enum class FileModelType {
    Image,
    PdfFile,
    File
}